module.exports = __webpack_public_path__ + "bed-quilt1.28967258.png";